import { render } from "./RequestItems.vue?vue&type=template&id=7b04377e"
import script from "./RequestItems.vue?vue&type=script&lang=js"
export * from "./RequestItems.vue?vue&type=script&lang=js"

import "./RequestItems.vue?vue&type=style&index=0&id=7b04377e&lang=css"

import exportComponent from "/var/www/html/auditoria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__